import useWhen from "hooks/useWhen";
import { END_OF_PILOT_25_ARGS } from "consts/feature-config";
import LandingEnd25 from "./landing-end-25";
import Landing from "./landing";

const LandingPage = () => {
  const useEndOfPilotLanding = useWhen(END_OF_PILOT_25_ARGS);

  return useEndOfPilotLanding ? <LandingEnd25 /> : <Landing />;
};

export default LandingPage;
